var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiamondUg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "39px",
    viewBox: "0 0 55 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDiamondUg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-upgrade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-Premium-(1)-Copy-9",
    transform: "translate(-253.000000, -141.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PlatinumDiamond",
    transform: "translate(253.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8636719,2 L41.6307432,10 L50.8006949,10 L43.1195192,2 L36.8636719,2 Z M34.5355158,2 L20.8545849,2 L15.7562113,10 L39.3025871,10 L34.5355158,2 Z M18.4829634,2 L11.2363582,2 L4.09611036,10 L13.3845899,10 L18.4829634,2 Z M31.4855546,30.6998021 L50.4101295,12 L41.5412266,12 L31.4855546,30.6998021 Z M23.4327616,30.5479007 L13.4587734,12 L4.59645335,12 L23.4327616,30.5479007 Z M15.7296029,12 L27.5,33.8885518 L39.2703971,12 L15.7296029,12 Z M28.2593177,36.6994003 L27.5,38.1114482 L26.6408238,36.5137006 L0.619921798,10.8912114 L10.3406653,-3.55271368e-15 L43.9718646,-3.55271368e-15 L54.4040501,10.8651966 L28.2593177,36.6994003 Z",
    id: "icDiamondUg"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiamondUg);
export default __webpack_public_path__ + "static/media/icDiamondUg.9d168bf9aa6c7cf3435019ac3955b47b.svg";
export { ForwardRef as ReactComponent };